import { Injectable } from '@angular/core';
import {
  State,
  Action,
  StateContext,
  Selector,
  NgxsAfterBootstrap,
  createSelector,
} from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { Hint } from '../../models/hint.model';
import { GetHints } from './hint.actions';
import { HintService } from '../../services/hint.service';
import { BotStateModel } from '../bot/bot.state';

export interface HintStateModel {
  hints: Array<Hint>;
}

@State<HintStateModel>({
  name: 'hint',
  defaults: {
    hints: [],
  },
})
@Injectable()
export class HintState implements NgxsAfterBootstrap {
  constructor(private hintService: HintService) {}

  ngxsAfterBootstrap({ dispatch }: StateContext<HintStateModel>): void {
    dispatch(GetHints);
  }

  @Selector()
  static getHints(state: HintStateModel) {
    return state.hints;
  }

  @Action(GetHints)
  getHints({ getState, setState }: StateContext<HintStateModel>, {}: GetHints) {
    return this.hintService.getHints().pipe(
      tap((result) => {
        if (result.status) {
          const state = getState();
          delete result.status;
          setState({
            ...state,
            hints: result.hints,
          });
        }
      })
    );
  }
}
